import React, { useRef, useState } from "react";
import "./carousel-desk.scss";
import ShowContainer from "../ShowContainer.jsx";
import CarouselDeskHeader from "./carousel_desk_header/CarouselDeskHeader.jsx";
import useGetItems from "../../../hooks/other/useGetItems.js";
import CustomCarousel from "../custom-carousel/CustomCarousel.jsx";

export default function CarouselDesk({ isRow2, items = [], title, children, showAllLink = "" }) {
  const sliderRef = useRef(null);
  const slidesToShow = useGetItems();

  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);

  const manyLength = items.length > slidesToShow;

  return (
    <ShowContainer condition={items.length}>
      <div className="carousel-desk">
        <CarouselDeskHeader
          title={title}
          showAllLink={showAllLink}
          sliderRef={sliderRef}
          manyLength={manyLength}
          slidesToShow={slidesToShow}
          disablePrev={disablePrev}
          disableNext={disableNext}
        />
        {manyLength ? (
          <CustomCarousel
            ref={sliderRef}
            onSwiper={(e) => (sliderRef.current = e)}
            className="carousel-desk__items"
            initialSlide={0}
            spaceBetween={10}
            speed={1000}
            loop={false}
            autoplay={false}
            allowTouchMove={true}
            slidesPerView={slidesToShow}
            freeMode={true}
            // loopAdditionalSlides={1}
            freeModeMomentumRatio={0.3}
            freeModeMomentumVelocityRatio={0.2}
            onActiveIndexChange={(e) => {
              const activeIndex = e.activeIndex;
              const maxItems = isRow2 ? items.length / 2 : items.length;

              setDisablePrev(activeIndex == 0);
              setDisableNext(activeIndex + slidesToShow >= maxItems);
              console.log(activeIndex, items.length);
            }}
            pagination={false}>
            {isRow2
              ? children
              : React.Children.map(children, (child, indx) => {
                  return (
                    <div key={indx} className="carousel-item" data-index={indx}>
                      {child}
                    </div>
                  );
                })}
          </CustomCarousel>
        ) : (
          <div className={`carousel-desk__items carousel-plug carousel-plug-${slidesToShow}`}>
            {children}
          </div>
        )}
      </div>
    </ShowContainer>
  );
}
